import { AxiosError } from "axios";
import {
  ArcElement,
  BarElement,
  CategoryScale,
  Chart as ChartJS,
  Legend,
  LineElement,
  LinearScale,
  PointElement,
  RadialLinearScale,
  Title,
  Tooltip,
} from "chart.js";
import "chartjs-plugin-datalabels";
import ChartDataLabels from "chartjs-plugin-datalabels";
import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { toast } from "react-toastify";
import { RootState } from "../../../app/store";
import { LineGraphData } from "../../../interface/DesignerInterface";
import Dropdown from "../Dropdown";
import TrendCurvesGraph from "./TrendCurvesGraph";

import Skeleton from "react-loading-skeleton";
import { trendCurvesFilters as dummyFilterType } from "../../../constants/constants";
import { formatAndSetDataForTrendCurves } from "../../../utils/trendSidebarGraphUtils/trendCurvesUtils";
import { useNavigate } from "react-router-dom";

ChartJS.register(
  RadialLinearScale,
  ArcElement,
  CategoryScale,
  LinearScale,
  BarElement,
  PointElement,
  LineElement,
  Tooltip,
  Legend,
  Title,
  ChartDataLabels,
  ChartDataLabels
);

interface TrendCurvesProps {
  analysisOpen?: boolean;
}
const TrendCurvesSidebar: React.FC<TrendCurvesProps> = ({ analysisOpen }) => {
  const [loading, setLoading] = useState(true);

  // const [filterType, setFilterType] = useState("Month on Month");

  const [filterType, setFilterType] = useState<string>("Most Popular");
  const [trendsCurveData, setTrendsCurveData] = useState<LineGraphData | null>(
    null
  );
  const navigate = useNavigate();

  const user = useSelector((state: RootState) => state.user.userInfo);

  const fetchTrendsCurveData = async () => {
    try {
      setLoading(true);
      await formatAndSetDataForTrendCurves(
        filterType,
        user,
        setTrendsCurveData
      );
    } catch (error) {
      console.error("Error Fetching trend curves data", error);
      if ((error as AxiosError)?.response?.status !== 400) {
        toast.error("Error Fetching bar graph data");
      }
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchTrendsCurveData();
  }, [filterType]);

  if (
    !(trendsCurveData || loading) ||
    (trendsCurveData &&
      trendsCurveData.datasets &&
      trendsCurveData.datasets.length === 0)
  ) {
    return <div className="my-4 text-center">No Trends Curves Data</div>;
  }

  return (
    <div className="mx-3">
      <div
        className="absolute right-2 top-1 text-right text-xs underline font-bold cursor-pointer"
        onClick={() => navigate("/designer-page/trend-curves")}
      >
        Expand
      </div>
      <div className="text-sm">Filter By</div>
      <Dropdown
        label={filterType || "Select type"}
        options={dummyFilterType}
        onSelect={option => {
          if (option !== filterType) {
            setFilterType(option);
          }
        }}
      />
      {!(trendsCurveData && trendsCurveData?.datasets?.length) || loading ? (
        <div className="my-10 flex items-center justify-center">
          <Skeleton height={300} width={430} />
        </div>
      ) : (
        <TrendCurvesGraph
          lineGraphData={trendsCurveData}
          trendsCurveExpandedView={false}
        />
      )}
    </div>
  );
};

export default TrendCurvesSidebar;
